import { componentCss, registerMerchantCss } from "@damga/ds";
import "@damga/ds/tokens.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { counterCss } from "./styles";
import { registerServiceWorker } from "./sw-register";

const style = document.createElement("style");
// Register first, then components: the register defines the tokens the
// components read, and both must land after the base stylesheet import.
style.textContent = registerMerchantCss + componentCss + counterCss;
document.head.append(style);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

registerServiceWorker();
